import { UiHitOverview } from './adjust-hit-overview.component';

export const columnFields: UiHitOverview[] = [
  {
    fieldLabel: 'Trademark Cited',
    fieldName: 'citedTrademarkName',
    fieldOrder: 1,
    checked: true,
  },
  {
    fieldLabel: 'Logo Cited',
    fieldName: 'citedLogo',
    fieldOrder: 2,
    checked: true,
  },
  {
    fieldLabel: 'Classes Cited',
    fieldName: 'citedClasses',
    fieldOrder: 3,
    checked: true,
  },
  {
    fieldLabel: 'Register',
    fieldName: 'register',
    fieldOrder: 4,
    checked: true,
  },
  {
    fieldLabel: 'Opposition Deadline',
    fieldName: 'oppositionDeadline',
    fieldOrder: 5,
    checked: true,
  },
  {
    fieldLabel: 'Owner',
    fieldName: 'owner',
    fieldOrder: 6,
    checked: true,
  },
  {
    fieldLabel: 'Goods and Services',
    fieldName: 'goodsAndService',
    fieldOrder: 7,
    checked: true,
  },
  {
    fieldLabel: 'Owner Country/Region',
    fieldName: 'ownerCountryOrRegion',
    fieldOrder: 8,
    checked: true,
  },
  {
    fieldLabel: 'Trademark Number',
    fieldName: 'trademarkNumber',
    fieldOrder: 9,
    checked: true,
  },
  {
    fieldLabel: 'App./Reg. Date',
    fieldName: 'appRegDate',
    fieldOrder: 10,
    checked: false,
  },
  {
    fieldLabel: 'Publication Date',
    fieldName: 'publicationDate',
    fieldOrder: 11,
    checked: false,
  },
  {
    fieldLabel: 'Opposition Strength',
    fieldName: 'oppositionStrength',
    fieldOrder: 12,
    checked: false,
  },
  {
    fieldLabel: 'Name',
    fieldName: 'nameRiskScore',
    fieldOrder: 13,
    checked: false,
  },
  {
    fieldLabel: 'Goods',
    fieldName: 'productRiskScore',
    fieldOrder: 14,
    checked: false,
  },
  {
    fieldLabel: 'Protection Claimed (WIPO)',
    fieldName: 'protectedCountries',
    fieldOrder: 15,
    checked: false,
  },
  {
    fieldLabel: 'Your Reference',
    fieldName: 'clientReference',
    fieldOrder: 16,
    checked: false,
  },
  {
    fieldLabel: ' Sub Client Reference',
    fieldName: 'subClientReference',
    fieldOrder: 17,
    checked: false,
  },
  {
    fieldLabel: 'Your Client',
    fieldName: 'subClientName',
    fieldOrder: 18,
    checked: false,
  },
  {
    fieldLabel: 'POCA Score',
    fieldName: 'pocaScore',
    fieldOrder: 19,
    checked: false,
  },
  {
    fieldLabel: 'Free Text',
    fieldName: 'freeText',
    fieldOrder: 20,
    checked: false,
  },
  {
    fieldLabel: 'Assignee',
    fieldName: 'assignee',
    fieldOrder: 21,
    checked: false,
  },
  {
    fieldLabel: 'Date Reported',
    fieldName: 'dateReported',
    fieldOrder: 22,
    checked: false,
  },
  {
    fieldLabel: 'Trademark Watched',
    fieldName: 'watchedTrademarkName',
    fieldOrder: 23,
    checked: false,
  },
  {
    fieldLabel: 'Logo Watched',
    fieldName: 'watchedLogo',
    fieldOrder: 24,
    checked: false,
  },
  {
    fieldLabel: 'Classes Watched',
    fieldName: 'watchedClasses',
    fieldOrder: 25,
    checked: false,
  },
  {
    fieldLabel: 'Product',
    fieldName: 'productCode',
    fieldOrder: 26,
    checked: false,
  },
];
